import { Link } from "react-router-dom";

// Affiche le texte d'un article à partir des blocs générés par scripts/blog.cjs
// (aucun HTML brut : titres, paragraphes, listes, citations, liens contrôlés).
const Inline = ({ nodes }) =>
  nodes.map((node, i) => {
    if (typeof node === "string") return node;
    if (node.strong) return <strong key={i} className="font-semibold text-ink">{node.strong}</strong>;
    if (node.em) return <em key={i}>{node.em}</em>;
    if (node.link.startsWith("/")) {
      return <Link key={i} to={node.link} className="underline underline-offset-4 decoration-accent hover:text-accent">{node.text}</Link>;
    }
    return <a key={i} href={node.link} target="_blank" rel="noopener noreferrer" className="underline underline-offset-4 hover:text-accent">{node.text}</a>;
  });

export default function BlogContent({ blocks }) {
  return blocks.map((block, i) => {
    switch (block.type) {
      case "h2":
        return <h2 key={i} className="font-display text-2xl sm:text-3xl font-bold tracking-tight mt-12 mb-4">{block.text}</h2>;
      case "h3":
        return <h3 key={i} className="font-display text-xl font-bold mt-8 mb-3">{block.text}</h3>;
      case "ul":
      case "ol": {
        const List = block.type;
        return (
          <List key={i} className={`${block.type === "ul" ? "list-disc" : "list-decimal"} pl-6 space-y-2 my-5 leading-relaxed text-ink/85`}>
            {block.items.map((item, j) => <li key={j}><Inline nodes={item} /></li>)}
          </List>
        );
      }
      case "quote":
        return <blockquote key={i} className="my-6 border-l-4 border-accent bg-white px-5 py-4 italic text-ink/80"><Inline nodes={block.content} /></blockquote>;
      default:
        return <p key={i} className="my-4 leading-relaxed text-ink/85"><Inline nodes={block.content} /></p>;
    }
  });
}
